import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import PatientIdentityContext from "src/contexts/data/PatientIdentityContext";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import TrialInstitutionIdentityContext from "src/contexts/data/TrialInstitutionIdentityContext";
import { createPatientSubMenu } from "src/routing/navigation";

/**
 * Registers the patient submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation;
 * the trial-institution identity is optional and selects the institution-scoped route when present.
 */
const PatientSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);
    const { data: trialInstitutionIdentity } = useContext(TrialInstitutionIdentityContext);
    const { data: patientIdentity } = useContext(PatientIdentityContext);

    const subMenu = useMemo(
        () => {
            if (!trialIdentity || !patientIdentity) {
                return null;
            }

            return createPatientSubMenu(trialIdentity, trialInstitutionIdentity, patientIdentity);
        },
        [trialIdentity, trialInstitutionIdentity, patientIdentity]
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default PatientSubMenu;
